type Props = {
  time: string;
  className: string;
};

const Time: React.FC<Props> = (props: Props) => {
  return <time className={props.className}>{props.time}</time>;
};
export default Time;
